<template>
  <div
    class="modal"
    @click="clickBackHandler"
  >
    <div class="modal__content">
      <button
        class="modal__head decoration-bloc-titre"
        @click="clickClose"
      >
        {{ closeLabel }}
      </button>

      <div class="modal__body">
        <slot>
          <p>...</p>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    closeLabel: { type: String, default: 'close' },
  },

  data() {
    return {};
  },

  methods: {
    clickBackHandler({ target }) {
      if (target === this.$el) {
        this.$emit('close');
      }
    },

    clickClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus" scoped>
.modal {
  position: relative;
  display: flex;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 50%);

  &:after {
    content: '';
    position: absolute;
    z-index: 0;

    width: 100%;
    height: 100%;

    cursor: pointer;
  }
}

.modal__content {
  position: relative;
  z-index: 1;

  width: calc(100% - 20px);
  margin: 0 auto;

  +desktop() {
    width: 80%;
  }
}

.modal__head {
  @extends $roll;

  position: absolute;
  right: 80px;
  z-index: 1;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
  }
}

.modal__body {
  box-sizing: border-box;
  border: 2px solid black;
  border-radius: 10px;
  overflow: hidden;

  /* fix empty bottom space */
  >>> .player {
    margin-bottom: -4px;
  }
}
</style>
